export const stringToMoney = (string, fractions = 0) => {
  return new Intl.NumberFormat('pr-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: fractions,
    maximumFractionDigits: fractions,
  }).format(string);
};
